import React from "react";
import Table from "@mui/material/Table";
import DownloadIcon from "@mui/icons-material/Download";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import IconButton from "@mui/material/IconButton";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableContainer from "@mui/material/TableContainer";
import LinearProgress from "@mui/material/LinearProgress";
import TablePagination from "@mui/material/TablePagination";
import { SIZES, ALIGN, HTML_TAGS } from "../../common/constants/commonConstants.js";
import { CALLLOG_TABLE_COLUMNS } from "../../common/constants/logsModule/logsConstants.js";

const CallLogsTable = ({
    page,
    order,
    setPage,
    orderBy,
    calls = [],
    isLoading,
    rowsPerPage,
    onEdit,
    setRowsPerPage,
    columns = CALLLOG_TABLE_COLUMNS,
    handleRequestSort,
    filteredCallsLength, // ✅ renamed from filteredRolesLength
}) => {
    return (
        <TableContainer sx={{ mt: 2 }}>
            <Table size={SIZES.SMALL}>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell
                                key={column.id}
                                sortDirection={orderBy === column.id ? order : false}
                                sx={{
                                    width:
                                        column.id === "actions"
                                            ? 50
                                            : column.id === "callconnectionid"
                                            ? 200
                                            : 150,
                                }}
                            >
                                {column.isSortable ? (
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={orderBy === column.id ? order : "asc"}
                                        onClick={() => handleRequestSort(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                ) : (
                                    column.label
                                )}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {isLoading ? (
                        <TableRow>
                            <TableCell colSpan={columns.length} align={ALIGN.CENTER}>
                                <LinearProgress />
                            </TableCell>
                        </TableRow>
                    ) : calls.length > 0 ? (
                        calls.map((call) => (
                            <TableRow hover tabIndex={-1} key={call.callconnectionid || call.id}>
                                {columns.map((column) => {
                                    if (column.id === "actions") {
                                        return (
                                            <TableCell key={column.id}>
                                                <IconButton
                                                    size={SIZES.SMALL}
                                                    onClick={() =>
                                                        onEdit?.({ callId: call.callconnectionid || call.id })
                                                    }
                                                >
                                                    <DownloadIcon fontSize={SIZES.SMALL} />
                                                </IconButton>
                                            </TableCell>
                                        );
                                    }

                                    // ✅ Render full names directly (already concatenated in backend)
                                    if (column.id === "agentfullname" || column.id === "customerfullname") {
                                        return (
                                            <TableCell key={column.id}>
                                                {call[column.id] || ""}
                                            </TableCell>
                                        );
                                    }

                                    return (
                                        <TableCell key={column.id}>
                                            {call[column.id] ?? ""}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={columns.length} align={ALIGN.CENTER}>
                                No records found.
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
            <TablePagination
                page={page}
                rowsPerPage={rowsPerPage}
                component={HTML_TAGS.DIV}
                count={filteredCallsLength} // ✅ updated prop name
                rowsPerPageOptions={[10, 25, 50]}
                onPageChange={(event, newPage) => setPage(newPage)}
                onRowsPerPageChange={(event) => {
                    setPage(0);
                    setRowsPerPage(parseInt(event.target.value, 10));
                }}
            />
        </TableContainer>
    );
};

export default CallLogsTable;
